@if (tableColumn.filter) {
  @if(tableColumn.filter.type === 'multiselect') {
    <p-columnFilter
      [field]="tableColumn.field"
      [matchMode]="'in'"
      display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
    >
      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
        <p-multiSelect
          [ngModel]="value"
          [options]="tableColumn.filter.multiselectOptions || []"
          placeholder="Any"
          (onChange)="filter($event.value)">
        </p-multiSelect>
      </ng-template>
    </p-columnFilter>
  } @else {
    <p-columnFilter
      [type]="tableColumn.filter.type || 'text'"
      [field]="tableColumn.field"
      display="menu"
    />
  }
}